import { render, staticRenderFns } from "./ReferencesField.vue?vue&type=template&id=0add6724&scoped=true&"
import script from "./ReferencesField.vue?vue&type=script&lang=js&"
export * from "./ReferencesField.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesField.vue?vue&type=style&index=0&id=0add6724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0add6724",
  null
  
)

export default component.exports